import { ThemeEvents } from '@theme/events';

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-part-number-wrapper]')
    .forEach((wrapper) => {
      const skuEl = wrapper.querySelector('[data-product-part-number]');
      if (!skuEl) return;

      const target = wrapper.closest(
        '[id*="ProductInformation-"], [id*="QuickAdd-"], product-card'
      );
      if (!target) return;

      target.addEventListener(ThemeEvents.variantUpdate, (event) => {
        const variant = event?.detail?.resource;
        if (!variant) return;

        const sku = variant.sku || '';
        wrapper.style.display = sku ? 'block' : 'none';
        skuEl.textContent = sku;
      });
    });
});
